import { Directive, Input, ViewContainerRef } from '@angular/core';

/**
 * Component Host Directive
 * serves as template reference for projected components
 *
 * @class ComponentHostDirective
 * @typedef {ComponentHostDirective}
 */
@Directive( {
    selector: '[appComponentHost]',
    standalone: true
} )
export class ComponentHostDirective {
    /** reference on data input */
    @Input() data: any;

    /** reference on view container */
    constructor( public viewContainerRef: ViewContainerRef ) {/** */ }
}
